export const FacebookUrl = "https://www.facebook.com/scmpstyle";
export const TwitterUrl = "https://twitter.com/scmp_style";
export const InstagramUrl = "https://www.instagram.com/scmp_style";
